var map = {
	"./logo-alphabet.svg": 539,
	"./logo-amazon-2.svg": 540,
	"./logo-amazon.svg": 580,
	"./logo-azercell.svg": 581,
	"./logo-bank-of-america.svg": 582,
	"./logo-barclays.svg": 583,
	"./logo-bbc.svg": 584,
	"./logo-bloomberg.svg": 541,
	"./logo-bnp-paribas.svg": 585,
	"./logo-booking.svg": 586,
	"./logo-citibank.svg": 587,
	"./logo-cnbc.svg": 542,
	"./logo-cnbc2.svg": 588,
	"./logo-coca-cola-auto.svg": 543,
	"./logo-coca-cola-white.svg": 1441,
	"./logo-coca-cola.svg": 589,
	"./logo-deloitte.svg": 590,
	"./logo-experian.svg": 591,
	"./logo-facebook.svg": 592,
	"./logo-forbes.svg": 544,
	"./logo-g.svg": 1442,
	"./logo-goldman-sachs-new.svg": 593,
	"./logo-goldman-sachs.svg": 1303,
	"./logo-google-new.svg": 594,
	"./logo-google.svg": 595,
	"./logo-h.svg": 596,
	"./logo-henkel.svg": 597,
	"./logo-hsbc-new.svg": 598,
	"./logo-hsbc.svg": 1304,
	"./logo-ikea-new.svg": 599,
	"./logo-ikea.svg": 1443,
	"./logo-infineon.svg": 600,
	"./logo-instagram-icon.svg": 545,
	"./logo-instagram.svg": 601,
	"./logo-jp-morgan.svg": 602,
	"./logo-jti.svg": 603,
	"./logo-linkedin.svg": 604,
	"./logo-meta-new.svg": 546,
	"./logo-meta.svg": 1305,
	"./logo-morgan-stanley-new.svg": 605,
	"./logo-morgan-stanley.svg": 1306,
	"./logo-netflix.svg": 1307,
	"./logo-oracle.svg": 547,
	"./logo-paypal.svg": 606,
	"./logo-pwc-new.svg": 548,
	"./logo-pwc.svg": 1444,
	"./logo-spotify.svg": 1308,
	"./logo-tesla.svg": 607,
	"./logo-usa-today.svg": 549,
	"./logo-visa.svg": 608,
	"./logo-walmart.svg": 550,
	"./logo-wsj.svg": 551,
	"./logo-youtube.svg": 609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1110;